import { createFileRoute } from "@tanstack/react-router";
import { ProductRouteError } from "@/session/product-route-frame";
import { OnboardingLoading } from "@softmax/product-ux/onboarding";
import { getStartPage } from "@/features/play/records";
import { StartPage } from "@/features/play/start";

export const Route = createFileRoute("/_site/unlisted/$coworld/start")({
  loaderDeps: ({ search }) => search,
  loader: ({ location, abortController }) =>
    getStartPage({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  staleTime: 0,
  gcTime: 0,
  pendingComponent: OnboardingLoading,
  errorComponent: ProductRouteError,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData ? `${loaderData.title} · Softmax` : "Start · Softmax",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: loaderData
      ? [{ rel: "canonical", href: loaderData.canonicalHref }]
      : [],
  }),
  component: () => <StartPage data={Route.useLoaderData()} />,
});
